import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import { Employee, SearchOffer } from '../../models/models';

@Component({
    selector: 'search-offer-grid',
    templateUrl: './search-offer-grid.component.html',
    standalone: false
})
export class SearchOfferGrid implements OnInit, OnChanges {
    @Input() quoteOrderID: number = 0;
    @Input() employees: Employee[] = [];
    @Output() openOfferLoadClick = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public offersGrid!: GridComponent;

    public isLoading: boolean = false;
    public offerList: SearchOffer[] = [];

    public gridState: State = { skip: 0, take: 10 };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private cseService: CSEService, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getOffers();
    }

    ngOnChanges() {
        this.getOffers();
    }

    private getOffers() {
        if (this.quoteOrderID > 0) {
            this.cseService.getSearchOfferByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.offerList = result.resultCollection;
                this.offerList = this.offerList.filter(o => o.offerRate > 0 || o.isDeclined == true);
                this.setOffersGrid();
                //console.log("getOffers", this.offerList);
            });
        }
        else {
            this.cseService.getSearchOfferOpenOffers().subscribe(result => {
                this.offerList = result.resultCollection;
                this.setOffersGrid();
                //console.log("getOffers", this.offerList);
            });
        }
    }

    public refreshOffers() {
        this.offerList.length = 0;
        this.getOffers();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.offersGrid == null) return;
            this.offersGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setOffersGrid();
    }

    public setOffersGrid() {
        this.gridData = process(this.offerList, this.gridState);
        this.fitColumns();
    }

    public openOffer(offer: SearchOffer) {
        this.openOfferLoadClick.emit(offer.quoteOrderLineID);
    }
}
